export enum EFlaskType {
    H1 = 1,
    H2 = 2,
    H3 = 3,
    H4 = 4,
    S1 = 5,
    H6 = 6,
    LS26N = 7,
    P17,
    P02
}